import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Foundations'

export const PasswordCriteriaListStyled = styled.dl({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.smx1,
})

export const PasswordCriteriaListDetailsStyled = styled.dd<{ isValid: boolean }>(
  {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.smx1,
    marginInlineStart: 0,

    '& > svg': {
      paddingInlineEnd: '0.5rem',
      '@supports not (padding-inline: 0)': {
        paddingRight: '0.5rem',
      },
    },
    ...font.size.lg,
    fontFamily: font.family.primary,
    '@supports not (margin-inline: 0)': {
      marginLeft: 0,
    },
  },
  ({ isValid }) => ({
    color: isValid ? colors.success['500'] : colors.neutral['700'],
  })
)
